import { ApiReturnMfe } from '@highimpact-frontend/api-types';
import { PlotFormProps } from '../../../../forms/InitiWidgetFormHandler';
import {
  getSpecificWidgetType,
  setElementType,
} from '../../../../state/dashboard-element-operations';
import WidgetTypeInitiatorForm from '../../commons/forms/WidgetTypeInitiatorForm';

interface PluginGroupInitiatorFormProps extends PlotFormProps {
  pluginMfes: ApiReturnMfe[];
}

function PluginGroupInitiatorForm({
  pluginMfes,
  ...formProps
}: PluginGroupInitiatorFormProps) {
  if (pluginMfes.length === 0) {
    return <p>Aucun élément disponible pour ce plugin.</p>;
  }

  return (
    <WidgetTypeInitiatorForm
      {...formProps}
      typeSelectorLabel="Type d'élément"
      options={pluginMfes.map((mfe) => ({
        id: mfe.name,
        label: mfe.pretty_name,
      }))}
      getSelectedTypeId={(config) =>
        getSpecificWidgetType(config) ?? pluginMfes[0].name
      }
      onTypeChange={(typeId, config) => {
        const mfe = pluginMfes.find((entry) => entry.name === typeId);
        if (!mfe) {
          return config;
        }

        return setElementType('remotewidget', config, false, {
          specificWidgetType: mfe.name,
          url: mfe.url,
        });
      }}
    />
  );
}

export default PluginGroupInitiatorForm;
